export const BUYER="BUYER";
export const SUPPLIER="SUPPLIER";
export const APPROVER="APPROVER";
export const ADMIN="ADMIN";
export const STRATEGICUSER="STRATEGICUSER";
export const SUPPLIERSUPPORTPERSON="SUPPLIERSUPPORTPERSON";
export const SUPPLIERRELATIONSHIPMANAGER = "SUPPLIERRELATIONSHIPMANAGER";
export const VENTURECAPITALIST = "VENTURECAPITALIST";
export const ORGANIZATIONADMIN = "ORGANIZATIONADMIN";
export const LOCATIONADMIN = "LOCATIONADMIN";
export const LOCATIONEXECUTIVE = "LOCATIONEXECUTIVE";
export const CARBONACCOUNTANT = "CARBONACCOUNTANT";
